module.exports = __webpack_public_path__ + "static/media/biaacc1.3e7bb522.jpg";